import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { AccountSettings } from "@/features/account";

export const Route = createFileRoute("/_authenticated/admin/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="mx-auto max-w-4xl">
      <PageHeader
        eyebrow="The Motherhood"
        title="Settings"
        description="Your name, your title, and how you sign in."
      />
      <AccountSettings />
    </div>
  );
}
